import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SystemPrompts } from '../components/SystemPrompts/SystemPrompts';
import ArticlePromptsPanel from '../components/ArticlePrompts/ArticlePromptsPanel';
import PageTabs from '../components/shared/PageTabs';

const SystemPromptsPage = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'article' ? 'article' : 'system';

  return (
    <div className="flex flex-col h-full">
      <div className="flex-shrink-0 mb-4">
        <h2 className="text-2xl font-bold">{t('sidebar.system_prompts')}</h2>
      </div>

      <div className="flex-shrink-0">
        <PageTabs
          tabs={[
            { id: 'system', label: t('sidebar.system_prompts') },
            { id: 'article', label: t('sidebar.articlePrompts') },
          ]}
          active={activeTab}
          onChange={(id) => setSearchParams(id === 'system' ? {} : { tab: id })}
        />
      </div>

      <div className="flex-grow min-h-0 overflow-y-auto">
        {activeTab === 'article' ? <ArticlePromptsPanel /> : <SystemPrompts />}
      </div>
    </div>
  );
};

export default SystemPromptsPage;
